export default {
  isInVehiclesModule: function (modules = [], setCriterial, currentModule) {
    if (!(modules.indexOf(currentModule) > -1)) {
      setCriterial({
        currentPage: 1,
        query: "",
        limit: 1,
        status: false,
      });
    }
  }
}